import script from "./ButtonScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonScroll.vue?vue&type=script&setup=true&lang=js"

import "./ButtonScroll.vue?vue&type=style&index=0&id=cda061f2&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cda061f2"]])

export default __exports__